import type { IconSvgObject } from './types';

const VideoOffIcon: IconSvgObject = [
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 14V6.5C18 5.39543 17.1046 4.5 16 4.5H8.5M4 4.5C2.89543 4.5 2 5.39543 2 6.5V17.5C2 18.6046 2.89543 19.5 4 19.5H16C16.9319 19.5 17.715 18.8626 17.937 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M22 17V6.5L18 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default VideoOffIcon;
